import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';

import { MenuTrigger } from './menu-trigger';
import { MenuContent } from './menu-content';
import { UserDTO } from '@/entities/layout/model/types';

interface SidebarFooterProps {
  user?: UserDTO;
  isCollapsed: boolean;
  isMobile: boolean;
}

export const SidebarFooter = ({ user, isCollapsed, isMobile }: SidebarFooterProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <MenuTrigger user={user} isCollapsed={isCollapsed} />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56 mb-1" side={isMobile ? 'top' : 'right'}>
        <MenuContent />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
